"use client";

import {
  GAM_HOME_INLINE_AD_UNIT,
  GAM_HOME_INLINE_ENABLED,
  GAM_HOME_INLINE_MIN_HEIGHT,
  GAM_HOME_INLINE_SIZES,
} from "@/components/ads/config";

import MobileGamInlineAd from "./MobileGamInlineAd";

export default function HomeMobileInlineAd() {
  if (!GAM_HOME_INLINE_ENABLED) return null;

  return (
    <MobileGamInlineAd
      id="home-mobile-inline"
      adUnit={GAM_HOME_INLINE_AD_UNIT}
      sizes={GAM_HOME_INLINE_SIZES}
      minHeight={GAM_HOME_INLINE_MIN_HEIGHT}
      placement="home_mobile_inline"
      pageType="home"
      targeting={{
        route_context: "home",
      }}
    />
  );
}
